<div class="p-3 sm:p-6 chart-page-container flex flex-col" *transloco="let t">
  <!-- Gráfico de Vendas (barras) -->
  <div class="bg-white shadow-lg rounded-lg p-4 sm:p-6 flex-1 flex flex-col">
    <div class="flex flex-col sm:flex-row items-start sm:items-baseline justify-between mb-3 gap-2">
      <div class="flex items-center space-x-2 w-full sm:w-auto">
        <label for="startDate" class="text-sm font-medium text-gray-700 whitespace-nowrap">{{ t('charts.startDate') }}</label>
        <input [(ngModel)]="startDate" type="date" id="startDate" (change)="ConfigureSalesWeeklyComparisonChart()"
          class="block w-full sm:w-auto px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm">
      </div>
      <span class="text-xs text-gray-400 ml-auto">{{ t('charts.updatedAt') }} {{chartOptionsSalesWeeklyComparison.lastUpdate | date: 'dd/MM/yyyy HH:mm'}}</span>
    </div>
    
    <div class="flex-1 min-h-0 w-full relative" style="max-width: 100%; overflow: visible; min-height: 320px;">
      <apx-chart *ngIf="!loadingSalesWeeklyComparison" [series]="chartOptionsSalesWeeklyComparison.series"
        [chart]="chartOptionsSalesWeeklyComparison.chart" [xaxis]="chartOptionsSalesWeeklyComparison.xaxis"
        [title]="chartOptionsSalesWeeklyComparison.title" [tooltip]="chartOptionsSalesWeeklyComparison.tooltip"
        [responsive]="chartOptionsSalesWeeklyComparison.responsive" [theme]="chartOptionsSalesWeeklyComparison.theme" style="height:100%; width:100%; display:block;">
      </apx-chart>

      <div *ngIf="loadingSalesWeeklyComparison" class="absolute inset-0 flex flex-col items-center justify-center gap-3 text-gray-500">
        <span class="h-9 w-9 rounded-full border-4 border-gray-200 border-t-blue-600 animate-spin"></span>
        <span class="text-sm">{{ t('common.loading') }}</span>
      </div>
    </div>
  </div>
</div>